import * as constants from 'helper/constants';
import React, { PureComponent } from 'react';
import { Redirect } from 'react-router-dom';

/*
 *  A component to handle the user's entry state,
 *  and redirect them appropriately.
 */

export default class Home extends PureComponent {
  constructor(props) {
    super(props);

    this.user = this.props.user;
    this.loadingStatus = this.props.loadingStatus;
  }

  render() {
    if (this.loadingStatus === constants.api.success) {
      return <Redirect to={`/details${this.props.location.search}`} />;
    }
    if (this.loadingStatus === constants.api.unauthorized && !(window.location.pathname.includes('login') || window.location.pathname.includes('signup'))) {
      return <Redirect to={`/login${this.props.location.search}`} />;
    }

    return null;
  }
}



// WEBPACK FOOTER //
// ./src/modules/Home.jsx